export interface IUserDiagnostic {
  id: string;
  operatorId: string;
  operatorEmail: string;
  organizationId: string;
  organizationName: string;
  appVersion: string;
  addedAtUtc: string;
  hasDiagnosticsPackage: boolean;

  //DiagnosticsContext
  userSubject: string;
  userDescription: string;
  rawInfoContext: string;

  state: UserDiagnosticsState,
  azureDevopsLink: string | null;
  fileEntries: IUserDiagnosticsFileEntry[] | null;
  userDiagnosticsTags: UserDiagnosticsTag[] | null;
}

export interface IUserDiagnosticResponse {
  id: string;
  organizationId: string;
  organizationName: string;
  operatorId: string;
  operatorEmail: string;
  appVersion: string;
  diagnosticsPackageBlobUrl: string;
  state: UserDiagnosticsState,
  azureDevopsLink: string | null;
  fileEntries: IUserDiagnosticsFileEntryReponse[] | null;
  userDiagnosticsContext: IDiagnosticsContextDtoResponse;
  addedAtUtc: string;
  userDiagnosticsTags: UserDiagnosticsTag[] | null;
}

export interface IUserDiagnosticsFileEntryReponse {
  fileType: UserDiagnosticsFileType,
  relativeFilePath: string
}

export interface IDiagnosticsContextDtoResponse {
  userSubject: string;
  userDescription: string;
  rawInfoContext: string;
}

export interface IUserDiagnosticsFileResponse {
  blob: Blob
  fileName: string;
  status: number;
}

export interface ICreateTicketRequest {
  userDiagnosticId: string
  devopsTicketOptions: IDevopsTicketOptions | null
}

export interface IDevopsTicketOptions {
  customSubject?: string,
  customDescription?: string
  devopsProject?: string
  devopsSport?: string
}

export interface IUpdateStateRequest {
  userDiagnosticId: string,
  newState: UserDiagnosticsState
}

export interface IUpdateDevopsLinkRequest {
  userDiagnosticId: string,
  newLink: string | null;
}

export interface IUserDiagnosticsRequestDto {
  updatedAfter?: string
  includeDeleted: boolean,
  pageSize: number,
  page: number
}

export interface IUserDiagnosticsFileEntry {
  fileType: UserDiagnosticsFileType,
  relativeFilePath: string
}

export interface IUserDiagnosticsDownloadFileRequestDto {
  specificFileType?: UserDiagnosticsFileType | null;
  specificFileUrl?: string | null;

}

export interface IUserDiagnosticsSelectedFile {
  userDiagnosticsId: string,
  fileName: string,
  blob: Blob | null
}

export enum UserDiagnosticsState {
  New = 0,
  Tracked = 1,
  Closed = 2
}

export enum UserDiagnosticsFileType {
  AuxillaryFile = 0,
  IpadLog = 1,
  RadarLog = 2,
  CameraLog = 3
}

export enum UserDiagnosticsTag {
  Crash = 0,
  NoTrigger = 1,
  Tracking = 2,
  Connection = 3,
}